import React from 'react'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import PresentationCard from 'components/card/PresentationCard'
import { IMPORT_TYPE, STATION_INTEGRATION, DATA_ADD_LAST_DATA } from 'traitements/constants/TraitementConstants'
import { InsertChart, MultilineChart, ShowChart, PieChart } from '@mui/icons-material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

const defaultSize = 60

const getDefaultParams = (stationType) => {
    switch (stationType) {
        case IMPORT_TYPE.HYDRO_PORTAIL:
            return {
                filters: [],
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA, 'withPred', 'heightIntegration', 'debitIntegration', 'withEvents', 'withThresholds'],
            }
        default:
            return { filters: {}, dataTypes: [] }
    }
}

const updateParams = (stationType, setFilters, setJobDataTypes) => {
    const params = getDefaultParams(stationType)
    setFilters(params.filters)
    setJobDataTypes(params.dataTypes)
}


const AddTreatementStepTreatment = ({
    changeStation,
    nextStep,
    setFilters,
    setJobDataTypes,
    setChoices,
}) => {
    return (
        <>
            <Grid container justifyContent='center' alignItems='center'>
                <h4>{i18n.newStationStep1}</h4>
            </Grid>
            <Grid container justifyContent='center' alignItems='center' spacing={3}>
                <Grid size={5} >
                    <PresentationCard
                        iconComponent={<InsertChart sx={{ fontSize: defaultSize }} />}
                        title={i18n.hydroStation}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TRAITEMENT_TYPE: `(${i18n.hydroStation})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE.HYDRO_PORTAIL })
                            updateParams(IMPORT_TYPE.HYDRO_PORTAIL, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.quantitativeManagementOfSurfaceWaters}
                    />
                </Grid>
                <Grid size={5}>
                    <PresentationCard
                        iconComponent={<ShowChart sx={{ fontSize: defaultSize }} />}
                        title={i18n.piezometry}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TRAITEMENT_TYPE: `(${i18n.piezometry})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE.PIEZO_PORTAIL })
                            updateParams(IMPORT_TYPE.PIEZO_PORTAIL, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.quantitativeManagementOfGroundwater}
                    />
                </Grid>
                <Grid size={5}>
                    <PresentationCard
                        iconComponent={<MultilineChart sx={{ fontSize: defaultSize }} />}
                        title={i18n.pluviometry}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TRAITEMENT_TYPE: `(${i18n.pluviometry})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE.PLUVIO_PORTAIL })
                            updateParams(IMPORT_TYPE.PLUVIO_PORTAIL, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.managementOfClimateData}
                    />
                </Grid>
                <Grid size={5}>
                    <PresentationCard
                        iconComponent={<PieChart sx={{ fontSize: defaultSize }} />}
                        title={i18n.quality}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TRAITEMENT_TYPE: `(${i18n.quality})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE.QUALITO })
                            updateParams(IMPORT_TYPE.QUALITO, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.qualityDataManagementAcrossAllDomains}
                    />
                </Grid>
                <Grid size={5}>
                    <PresentationCard
                        iconComponent={<MoreHorizIcon sx={{ fontSize: defaultSize }} />}
                        title={i18n.others}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TRAITEMENT_TYPE: `(${i18n.others})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE.OTHER })
                            updateParams(IMPORT_TYPE.OTHER, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.qualityDataManagementAcrossAllDomains}
                    />
                </Grid>
            </Grid>
        </>
    )
}

AddTreatementStepTreatment.propTypes = {
    nextStep: PropTypes.func,
    changeStation: PropTypes.func,
    setFilters: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    setChoices: PropTypes.func,
}

export default AddTreatementStepTreatment